// @ts-ignore
export function emptyObjValueOfAll<T = any>(obj: T = {}): T {
  // @ts-ignore
  const ob: T = {};
  // @ts-ignore
  Object.keys(obj).forEach((k) => {
    // @ts-ignore
    const v = obj[k];
    if (v !== undefined && v && v !== "all") {
      // @ts-ignore
      ob[k] = v;
    }
  });
  return ob;
}

// @ts-ignore
export function emptyObjValueOfAll2<T = any>(obj: T = {}, obj2: T = {}): T {
  const ob1 = emptyObjValueOfAll(obj);
  const ob2 = emptyObjValueOfAll(obj2);
  return { ...ob1, ...ob2 };
}
